export default "__VITE_ASSET__CcfZvP4J__"